export enum EFinancingUxFeedbackModal {
  FORM = 'FORM',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
